import { render, staticRenderFns } from "./RapidIceSwitch.vue?vue&type=template&id=dbc3e0fe&scoped=true"
import script from "./RapidIceSwitch.vue?vue&type=script&lang=ts"
export * from "./RapidIceSwitch.vue?vue&type=script&lang=ts"
import style0 from "./RapidIceSwitch.vue?vue&type=style&index=0&id=dbc3e0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc3e0fe",
  null
  
)

export default component.exports